module.exports = __webpack_public_path__ + "static/img/right.714771eb.gif";